import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import Feature from '../Feature';
import HouseLabelCircledIcon from '../../icons/HouseLabelCircledIcon';
import Button from '../../Button';

import { LANDLORD_TYPE_FEATURE } from '../featureList';

import VerificationIconWrapper from '../../VerificationIconWrapper';

import LLInfo from '../../ListingLabel/LLInfo';

const LandlordType = ({
  collapsed = false,
  onCollapsedChange = () => {},
  openVerificationModal = () => {},
  landlordInformation = {},
  loading = false,
  onClick = () => {}
}) => {
  const renderBody = () => (
    <>
      <LLInfo
        landlordInformation={landlordInformation}
        loading={loading}
        onClick={onClick}
      >
        <Button color="link" onClick={openVerificationModal}>
          {trans('listing.verification.more-button')}
        </Button>
      </LLInfo>
    </>
  );

  const renderIcon = () => (
    <VerificationIconWrapper>
      <HouseLabelCircledIcon />
    </VerificationIconWrapper>
  );

  return (
    <Feature
      featureName={LANDLORD_TYPE_FEATURE}
      collapsed={collapsed}
      onCollapsedChange={onCollapsedChange}
      renderBody={renderBody}
      renderIcon={renderIcon}
      headerKey={'listing.landlord_info.verified_landlord'}
    />
  );
};

LandlordType.propTypes = {
  collapsed: PropTypes.bool,
  onCollapsedChange: PropTypes.func,
  openVerificationModal: PropTypes.func,
  onClick: PropTypes.func,
  landlordInformation: PropTypes.shape({
    type: PropTypes.oneOf(['professional', 'private'])
  }),
  loading: PropTypes.bool
};

export default LandlordType;
